/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Format_Storyline_HintInputs */



/**
* | output |
* | --- |
* | "Storyline events take no decklist: they use their own rules and cards." |
*
* @param {Tfield_Format_Storyline_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_format_storyline_hint = /** @type {((inputs?: Tfield_Format_Storyline_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Format_Storyline_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les tournois Storyline n'ont pas de decklist : ils ont leurs propres règles et cartes.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los torneos Storyline no llevan decklist: tienen sus propias reglas y cartas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneios Storyline não têm decklist: usam regras e cartas próprias.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I tornei Storyline non richiedono decklist: hanno regole e carte proprie.")
	return /** @type {LocalizedString} */ ("Storyline events take no decklist: they use their own rules and cards.")
});